module.exports = __webpack_public_path__ + "img/bmat_logo.37e9af80.svg";